import script from "./BookingDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingDialog.vue?vue&type=script&setup=true&lang=js"

import "./BookingDialog.vue?vue&type=style&index=0&id=fac7f43c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fac7f43c"]])

export default __exports__